import mooseJaw from './cities/mooseJaw'
import princeAlbert from './cities/princeAlbert'
import regina from './cities/regina'
import saskatoon from './cities/saskatoon'
import yorkton from './cities/yorkton'

export default {
  'province': 'Saskatchewan',
  'abbr': 'Sask.',
  'alpha': 'SK',
  'lawSociety': 'Law Society of Saskatchewan',
  'writeup': '',
  'cities': [
    mooseJaw,
    princeAlbert,
    regina,
    saskatoon,
    yorkton
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/saskatchewan/index.js